import React from 'react'

import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { ConfigurableTable } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config/context'
import { useOrder } from '../../data'

interface Props {
  id: string
}

export const AllowanceCharges: React.FC<Props> = ({ id }) => {
  const { data: order, isLoading } = useOrder(id)
  const { uiConfig: config } = useConfigContext()

  return (
    <>
      <h3>
        {getConfigTranslation(
          config.orderResponse.orderInformation.allowanceCharges.title,
        )}
      </h3>
      <ConfigurableTable
        config={config.orderResponse.orderInformation.allowanceCharges.table}
        data={order?.Payload?.AllowanceCharges}
        isLoading={isLoading}
        stateKey=""
      />
    </>
  )
}
